import {
  IonButton, IonButtons, IonCard, IonImg, IonItemDivider, IonLabel, IonText,
} from '@ionic/react';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import CalendarMini from '@/assets/imgs/calendar-mini.svg';
import PaymentMini from '@/assets/imgs/payment-mini.svg';
import shopMini from '@/assets/imgs/shop-mini.svg';
import { ManagedModalRoutes } from '@/interfaces/ManagedModalInterface/ManagedModalInterface';
import { RootState } from '@/store';
import { formatPrice } from '@/utils/pricesHelper';

import styles from './ConfirmedCustomerShipment.module.scss';

interface ConfirmedCustomerShipmentProps {
  nextStep: (route: ManagedModalRoutes, isEmail?: boolean) => void;
  handleLoading: (e: boolean) => void;
  isEmail?: boolean;
}

export default function ConfirmedCustomerShipment({
  handleLoading,
  nextStep,
  isEmail,

}: ConfirmedCustomerShipmentProps) {
  const customer = useSelector((state: RootState) => state.orderData.data);
  const [firstQuota, setFirstQuota] = useState<string | null>('');
  const [monthlyPayment, setMonthlyPayment] = useState<string | null>('');
  const [totalQuotas, setTotalQuotas] = useState<string | null>('');
  useEffect(() => {
    if (customer) {
      // ejemplo
      setFirstQuota(formatPrice(customer?.data.cart.products[0].price));
      setMonthlyPayment(customer?.data.applicant.name);
      setTotalQuotas(customer?.data.term.toString());
    }
  }, [customer]);
  const handleContinue = async () => {
    nextStep(ManagedModalRoutes.SHIPPING_FINISHED_MANAGED);
  };

  useEffect(() => {
    handleLoading(false);
  }, []);

  return (
    <div className={styles.confirmedCustomerShipmentWrapper}>
      <div className={styles.orderManagedTitleDescriptionWrapper}>
        <div className={styles.orderManagedTitleWrapper}>
          <IonLabel className={styles.modalOrderManagedTitle}>Confirmar envío a cliente</IonLabel>
        </div>
        <div className={styles.modalOrderManagedDescriptionWrapper}>
          <IonLabel className={styles.modalOrderManagedDescription}>
            {isEmail
              ? `Se va a enviar el enlace a ${customer?.data.applicant.email} para que el cliente continúe con la financiación:`
              : `Se va a enviar el enlace al ${customer?.data.applicant.billing_address.phone} para que el cliente continúe con la financiación:`}
          </IonLabel>
          {' '}

        </div>
      </div>
      <div className={styles.confirmedCustomerHipmentList}>
        <div>
          <IonCard className={styles.confirmedCustomerCard}>
            <div className={styles.confirmedCustomerHipmentText}>
              <IonImg src={shopMini} className={styles.confirmedCustomerHipmentImg} />
              <IonText className={styles.confirmedCustomerHipmentOptionName}>Primera cuota</IonText>
              <IonText
                className={styles.confirmedCustomerHipmentCustomerData}
              >
                {firstQuota}
              </IonText>
            </div>
          </IonCard>
        </div>
        <IonItemDivider className={styles.divider} />
        <div>
          <IonCard className={styles.confirmedCustomerCard}>
            <div className={styles.confirmedCustomerHipmentText}>
              <IonImg src={PaymentMini} className={styles.confirmedCustomerHipmentImg} />
              <IonText className={styles.confirmedCustomerHipmentOptionName}>Pago mensual</IonText>
              <IonText
                className={styles.confirmedCustomerHipmentCustomerData}
              >
                {monthlyPayment}
              </IonText>
            </div>
          </IonCard>
        </div>
        <IonItemDivider className={styles.divider} />
        <div>
          <IonCard className={styles.confirmedCustomerCard}>
            <div className={styles.confirmedCustomerHipmentText}>
              <IonImg src={CalendarMini} className={styles.confirmedCustomerHipmentImg} />
              <IonText
                className={styles.confirmedCustomerHipmentOptionName}
              >
                Total de cuotas
              </IonText>
              <IonText
                className={styles.confirmedCustomerHipmentCustomerData}
              >
                {totalQuotas}
              </IonText>
            </div>
          </IonCard>
        </div>
      </div>
      <IonButtons className={styles.nextBtnWrapper}>
        <IonButton className="nextButton" onClick={handleContinue} disabled={false}>Continuar</IonButton>
      </IonButtons>
    </div>
  );
}
